import React, { Component } from 'react';
import Timer from 'react-timer-wrapper';
import Timecode from 'react-timecode';


class OpenInBrowser extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
      time: 0,
      duration: 0
    };
  
    this.onTimerUpdate = this.onTimerUpdate.bind(this);
    this.onStopTimer = this.onStopTimer.bind(this);

  }
  onTimerUpdate({time, duration}) {
    this.setState({
      time,
      duration,
    });
  }

  onStopTimer() {
    window.location.replace("https://blog.dakshgautam.com/");
  }
  
  render() {

    const {
      time,
      duration,
    } = this.state;
    return (
      <div id="mainC">
        <div class="message">
          <h1>
            
          <div className="timer-mobile">
            <Timer active duration={10 * 1000} onTimeUpdate={this.onTimerUpdate} onFinish={this.onStopTimer}/>
            <Timecode time={duration - time} />
          </div>
          </h1>
          <h3>Sorry!! Please visit the website using large screen devices.</h3>

          <h2>Meanwhile, read my tech blogs.</h2>
          <p className="p-redirect-p"><i>redirecting to <a href="https://blog.dakshgautam.com/"><u>Chai, Code & Life</u></a></i></p>
        </div>
      </div>
    );
  }
}

export default OpenInBrowser;



// WEBPACK FOOTER //
// ./src/components/OpenInBrowser.js